<template lang='html'>
  <svg
    class='top-arch'
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
    viewBox="0 0 1440 60"
    preserveAspectRatio="xMidYMin slice"
    version="1.1"
    id="svg12"
    sodipodi:docname="Tax _ Pilot-1 (1).svg"
    inkscape:version="0.92.3 (2405546, 2018-03-11)">
    <metadata
      id="metadata16">
      <rdf:RDF>
        <cc:Work
          rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type
            rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <sodipodi:namedview
      pagecolor="#ffffff"
      bordercolor="#666666"
      borderopacity="1"
      objecttolerance="10"
      gridtolerance="10"
      guidetolerance="10"
      inkscape:pageopacity="0"
      inkscape:pageshadow="2"
      inkscape:window-width="927"
      inkscape:window-height="609"
      id="namedview14"
      showgrid="false"
      inkscape:zoom="0.29791667"
      inkscape:cx="911.32867"
      inkscape:cy="30"
      inkscape:window-x="3079"
      inkscape:window-y="1011"
      inkscape:window-maximized="0"
      inkscape:current-layer="svg12"/>
    <defs
      id="defs3">
      <path
        id="path-1"
        d="M0 0h1440v60H0z"/>
    </defs>
    <g
      id="Desktop"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Home"
        transform="translate(0 -780)">
        <g
          id="Group-11"
          transform="translate(0 780)">
          <mask
            id="mask-2"
            fill="#fff">
            <use
              xlink:href="#path-1"
              id="use5"/>
          </mask>
          <path
            style="fill:#ECEFF1"
            mask="url(#mask-2)"
            d="M 5313,4593.5 A 4593.5,4593.5 0 0 1 719.5,9187 4593.5,4593.5 0 0 1 -3874,4593.5 4593.5,4593.5 0 0 1 719.5,0 4593.5,4593.5 0 0 1 5313,4593.5 Z"
            id="Oval"/>
        </g>
      </g>
    </g>
  </svg>

</template>

<script>
export default {
  name: 'YetAnotherArch',
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .top-arch {
    width: 100%;
    margin-bottom: 5px;
    padding: 0;
    background-color: #082543;
  }
</style>
